import React from "react";
import { Link } from "react-router-dom";

const categoryMeta: Record<string, { color: string; text: string; bar: string; icon: string }> = {
  finance:      { color: "bg-green-50 text-green-700 border-green-200",   text: "text-green-700",  bar: "bg-gradient-to-r from-green-500 to-emerald-500",  icon: "💰" },
  analytics:    { color: "bg-blue-50 text-blue-700 border-blue-200",      text: "text-blue-700",   bar: "bg-gradient-to-r from-blue-500 to-cyan-500",       icon: "📊" },
  marketing:    { color: "bg-orange-50 text-orange-700 border-orange-200",text: "text-orange-700", bar: "bg-gradient-to-r from-orange-500 to-red-500",      icon: "📣" },
  design:       { color: "bg-purple-50 text-purple-700 border-purple-200",text: "text-purple-700", bar: "bg-gradient-to-r from-purple-500 to-pink-500",     icon: "🎨" },
  developer:    { color: "bg-gray-100 text-gray-700 border-gray-200",     text: "text-gray-700",   bar: "bg-gradient-to-r from-gray-600 to-slate-700",     icon: "⚡" },
  productivity: { color: "bg-teal-50 text-teal-700 border-teal-200",      text: "text-teal-700",   bar: "bg-gradient-to-r from-teal-500 to-cyan-500",      icon: "🚀" },
};

interface ToolCardProps {
  tool: {
    name: string;
    slug: string;
    description: string;
    category: string;
    is_premium: number;
  };
}

export default function ToolCard({ tool }: ToolCardProps) {
  const meta = categoryMeta[tool.category] ?? { color: "bg-gray-100 text-gray-700 border-gray-200", text: "text-gray-700", bar: "bg-gray-400", icon: "🔧" };

  return (
    <div className="group relative border border-gray-200 rounded-2xl bg-white overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col">
      {/* top accent bar */}
      <div className={`h-1 w-full ${meta.bar}`} />

      <div className="p-6 flex flex-col flex-1">
        {/* badges row */}
        <div className="flex items-center gap-2 mb-4">
          <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${meta.color}`}>
            <span>{meta.icon}</span>
            <span className="capitalize">{tool.category}</span>
          </span>
          {tool.is_premium === 1 && (
            <span className="inline-flex items-center gap-1 text-xs font-bold px-2.5 py-1 rounded-full bg-gradient-to-r from-amber-400 to-orange-500 text-white shadow-sm">
              ⭐ PRO
            </span>
          )}
        </div>

        <h3 className="font-bold text-gray-900 text-base mb-2 leading-snug">{tool.name}</h3>
        <p className="text-gray-500 text-sm line-clamp-2 leading-relaxed flex-1">{tool.description}</p>

        <div className="mt-5 pt-4 border-t border-gray-100">
          <Link
            to={`/tools/${tool.slug}`}
            className={`inline-flex items-center gap-1 text-sm font-semibold ${meta.text} hover:opacity-70 transition-opacity`}
          >
            Try it now
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
}